import { Link, useLocation } from 'react-router-dom';
import { type DirectionsNavigationState } from '../components/useDirectionsNavigation';
import './DirectionsPage.css';

export function DirectionsPage() {
  const { state } = useLocation();
  const previous = state as DirectionsNavigationState | null;
  const returnTo = previous?.returnTo && /^\/(dashboard|appointments)(?:[?#]|$)/.test(previous.returnTo)
    ? previous.returnTo : '/appointments';

  return (
    <main className="directions-page" aria-labelledby="directions-title">
      <Link className="directions-page__back" to={returnTo} state={previous?.returnState} replace>
        <span aria-hidden="true">‹</span> Zurück zum Termin
      </Link>
      <h1 id="directions-title">Anfahrt und Parken</h1>

      <div className="directions-page__intro">
        <div className="directions-page__welcome">
          <h2>Bestens erreichbar. Parkhaus und Lift inklusive.</h2>
          <p>Willkommen in unserer Praxis im Herzen von Schaffhausen. Wir freuen uns darauf, Sie in unseren modernen Räumlichkeiten begrüssen zu dürfen.</p>
        </div>
        <figure className="directions-page__photo">
          <img
            src={`${process.env.PUBLIC_URL}/images/praxisgebaeude.jpg`}
            alt="Praxisgebäude von RiviDent in Schaffhausen"
            width={2752}
            height={1536}
            decoding="async"
          />
        </figure>
      </div>

      <div className="directions-page__travel">
        <section aria-labelledby="directions-car">
          <h2 id="directions-car">Anreise mit dem Auto</h2>
          <p>Zentral gelegen und bequem erreichbar. Wir bieten Ihnen exklusive Parkmöglichkeiten direkt im Parkhaus «Stricki».</p>
          <div className="directions-page__parking">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true" focusable="false">
              <circle cx="12" cy="12" r="10" />
              <path d="m7 12 3.5 3.5L17 9" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <div>
              <h3>Öffentliches Parkhaus «Stricki»</h3>
              <p>Der Zugang zur Praxis erfolgt direkt vom Parkhaus aus, 2. OG.</p>
            </div>
          </div>
        </section>

        <section aria-labelledby="directions-public">
          <h2 id="directions-public">Öffentlicher Verkehr</h2>
          <p>Dank der optimalen Lage im Stadtzentrum sind wir ideal an das öffentliche Verkehrsnetz angebunden.</p>
          <div className="directions-page__connection">
            <h3>Bus Linien</h3>
            <p>Bis zur Haltestelle «Bachstrasse» oder «Rhybadi».</p>
          </div>
          <div className="directions-page__connection">
            <h3>S-Bahn / Hauptbahnhof</h3>
            <p>Vom Bahnhof Schaffhausen sind es nur etwa 8 Minuten entspannter Fussweg.</p>
          </div>
        </section>
      </div>
    </main>
  );
}
